// import { Drawer, Button, Select, Table, InputNumber, Tag } from "antd";
// import { useState, useEffect } from "react";
// import PurchaseOrderService from "../services/PurchaseOrder/PurchaseOrderService";
// import ContainerService from "../services/Container/ContainerService";

// const { Option } = Select;

// export default function SplitOrderDrawer({
//   visible,
//   onClose,
//   purchaseOrderID,
//   selectedItems = [],
// }) {
//   const [selectedContainers, setSelectedContainers] = useState([]);
//   const [containerItemMapping, setContainerItemMapping] = useState({});
//   const [itemAssignments, setItemAssignments] = useState({});
//   const [containers, setContainers] = useState([]);

//   useEffect(() => {
//     if (!visible) {
//       setSelectedContainers([]);
//       setContainerItemMapping({});
//       setItemAssignments({});
//     }
//     fetchContainers();
//   }, [visible]);

//   const fetchContainers = async () => {
//     try {
//       const response = await ContainerService.getConatinerList();
//       setContainers(response.data);
//     } catch (error) {
//       console.error("Error fetching containers:", error);
//     }
//   };

//   // useEffect(() => {
//   //   console.log("Selected Items in Parent Component:", selectedItems);
//   // }, [selectedItems]);

//   const handleContainerSelection = (containers) => {
//     setSelectedContainers(containers.map(String));
//     setItemAssignments({});
//     setContainerItemMapping({});
//   };

//   const handleItemAssignment = (containerID, items) => {
//     const containerKey = String(containerID);

//     setItemAssignments((prev) => ({
//       ...prev,
//       [containerKey]: items.map(String), // Ensure item IDs are strings
//     }));

//     setContainerItemMapping((prev) => {
//       const updatedMapping = { ...prev };
//       updatedMapping[containerKey] = {};
//       items.forEach((itemID) => {
//         updatedMapping[String(containerKey)][String(itemID)] = "1"; // Default quantity as string
//       });
//       return updatedMapping;
//     });
//   };

//   const handleQuantityChange = (containerID, itemID, value) => {
//     setContainerItemMapping((prev) => ({
//       ...prev,
//       [String(containerID)]: {
//         ...prev[String(containerID)],
//         [String(itemID)]: String(value), // Convert quantity to string
//       },
//     }));
//   };

//   const dataSource = selectedContainers.flatMap((containerID) =>
//     (itemAssignments[containerID] || []).map((itemID) => ({
//       key: `${containerID}-${itemID}`,
//       containerID: String(containerID),
//       itemID: String(itemID),
//       quantity: String(containerItemMapping[containerID]?.[itemID] || "1"), // Ensure quantity is string
//     }))
//   );

//   const handleConfirm = async () => {
//     const formattedData = Object.entries(containerItemMapping).map(
//       ([containerID, items]) => ({
//         [containerID]: Object.fromEntries(
//           Object.entries(items).map(([itemID, quantity]) => [
//             String(itemID),
//             String(quantity),
//           ])
//         ),
//       })
//     );

//     const requestData = {
//       purchaseOrderID,
//       itemContainerMapping: formattedData,
//     };

//     console.log("Payload:", JSON.stringify(requestData, null, 2));

//     try {
//       await PurchaseOrderService.SplitOrder(requestData);
//       onClose();
//     } catch (error) {
//       console.error("Error splitting purchase order", error);
//     }
//   };

//   useEffect(() => {
//     console.log("Selected Containers:", selectedContainers);
//     console.log("Item Assignments:", itemAssignments);
//     console.log("Container Item Mapping:", containerItemMapping);
//   }, [selectedContainers, itemAssignments, containerItemMapping]);

//   const columns = [
//     {
//       title: "Container ID",
//       dataIndex: "containerID",
//       render: (containerID) => <Tag color="blue">Container {containerID}</Tag>,
//     },
//     {
//       title: "Item ID",
//       dataIndex: "itemID",
//     },
//     {
//       title: "Quantity",
//       dataIndex: "quantity",
//       render: (_, record) => (
//         <InputNumber
//           controls={false}
//           min={1}
//           value={Number(record.quantity)} // Display as number
//           onChange={(value) =>
//             handleQuantityChange(record.containerID, record.itemID, value)
//           }
//         />
//       ),
//     },
//   ];

//   return (
//     <Drawer
//       title="Split Purchase Order"
//       width={700}
//       onClose={onClose}
//       open={visible}
//     >
//       <div className="mb-4">
//         <label className="block font-semibold">Select Containers</label>
//         <Select
//           mode="multiple"
//           className="w-full mb-2"
//           placeholder="Select Containers"
//           onChange={handleContainerSelection}
//         >
//           {containers.length > 0 ? (
//             containers.map((container) => (
//               <Option key={String(container.id)} value={String(container.id)}>
//                 {container.number}
//               </Option>
//             ))
//           ) : (
//             <Option disabled>No containers available</Option>
//           )}
//         </Select>
//       </div>

//       {selectedContainers.length > 0 &&
//         selectedContainers.map((containerID) => (
//           <div key={containerID} className="mb-4">
//             <label className="block font-semibold">
//               Assign Items to Container {containerID}
//             </label>
//             <Select
//               mode="multiple"
//               className="w-full"
//               placeholder="Select Items"
//               onChange={(items) => handleItemAssignment(containerID, items)}
//             >
//               {selectedItems?.length > 0 ? (
//                 selectedItems.map((item) => (
//                   <Option key={String(item.id)} value={String(item.id)}>
//                     {item.sku}
//                   </Option>
//                 ))
//               ) : (
//                 <Option disabled>No items available</Option>
//               )}
//             </Select>
//           </div>
//         ))}

//       {dataSource.length > 0 ? (
//         <Table columns={columns} dataSource={dataSource} pagination={false} />
//       ) : (
//         <p className="text-gray-500">No items assigned yet.</p>
//       )}

//       <Button
//         type="primary"
//         onClick={handleConfirm}
//         disabled={selectedContainers.length === 0}
//         className="mt-4"
//       >
//         Confirm Split
//       </Button>
//     </Drawer>
//   );
// }

import { Button, Checkbox, Drawer, Table, Tag, message } from "antd";
import { useEffect, useState } from "react";
import PurchaseOrderService from "../services/PurchaseOrder/PurchaseOrderService";

export default function SplitOrderDrawer({
  visible,
  onClose,
  purchaseOrderID,
  selectedItems = [],
}) {
  const [items, setItems] = useState([]);
  const [selectedItemIds, setSelectedItemIds] = useState([]);

  useEffect(() => {
    if (visible) {
      prepareItemsForSplit();
    }
  }, [visible]);

  const prepareItemsForSplit = () => {
    const preselectedItems = selectedItems.filter(
      (item) => item.qtyOrdered > item.qtyReceived
    );
    setItems(selectedItems);
    setSelectedItemIds(preselectedItems.map((item) => item.id));
  };

  const toggleItemSelection = (itemId) => {
    setSelectedItemIds((prevSelected) =>
      prevSelected.includes(itemId)
        ? prevSelected.filter((id) => id !== itemId)
        : [...prevSelected, itemId]
    );
  };

  const handleConfirm = async () => {
    if (selectedItemIds.length === 0) {
      message.warning("Please select at least one item to split.");
      return;
    }

    const requestData = {
      purchaseOrderID,
      purchaseOrderItemIDs: selectedItemIds,
    };

    try {
      await PurchaseOrderService.createChildPurchaseOrder(requestData);
      message.success("Order successfully split!");
      onClose();
    } catch (error) {
      console.error("Error splitting purchase order:", error);
      message.error("Failed to split order.");
    }
  };

  const columns = [
    {
      title: "Select",
      dataIndex: "select",
      render: (_, record) => (
        <Checkbox
          checked={selectedItemIds.includes(record.id)}
          onChange={() => toggleItemSelection(record.id)}
        />
      ),
    },
    {
      title: "SKU",
      dataIndex: "sku",
      render: (text) => <Tag color="blue">{text}</Tag>,
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "PO Quantity",
      dataIndex: "qtyOrdered",
    },
    {
      title: "Supply Quantity",
      dataIndex: "qtyReceived",
    },
  ];

  return (
    <Drawer
      title="Split Purchase Order"
      width={700}
      onClose={onClose}
      open={visible}
    >
      <Table
        columns={columns}
        dataSource={items}
        rowKey="id"
        pagination={false}
      />
      <Button
        type="primary"
        onClick={handleConfirm}
        disabled={selectedItemIds.length === 0}
        className="mt-4"
      >
        Confirm Split
      </Button>
    </Drawer>
  );
}
